import React from "react";
import { useLang } from "../context/LanguageContext";
import { GENDERS, COMPLEXITY, CHARACTER, CLASS_TITLES } from "../lib/classifications";

const Title = ({ children }) => (
  <p className="text-[10px] uppercase tracking-[0.3em] text-[#8A857D]">{children}</p>
);

const LevelScale = ({ field, levels, value, lang }) => {
  const idx = levels.findIndex((l) => l.key === value);
  if (idx < 0) return null;
  const level = levels[idx];
  return (
    <div data-testid={`profile-${field}`} className="py-5 border-t border-[#1E1C19]">
      <div className="flex items-baseline justify-between gap-4">
        <Title>{CLASS_TITLES[field][lang]}</Title>
        <span className="serif text-lg text-[#F2EBE1]" data-testid={`profile-${field}-value`}>{level[lang]}</span>
      </div>
      <div className="grid grid-cols-4 gap-1.5 mt-3" role="meter" aria-valuemin={1} aria-valuemax={4} aria-valuenow={idx + 1} aria-label={CLASS_TITLES[field].en}>
        {levels.map((l, i) => (
          <span key={l.key} data-testid={`profile-${field}-seg-${i}`} data-active={i <= idx}
            className={`h-[3px] transition-colors duration-500 ${i <= idx ? "bg-[#C49A6C]" : "bg-[#2A2824]"}`} />
        ))}
      </div>
      <div className="grid grid-cols-4 gap-1.5 mt-2">
        {levels.map((l, i) => (
          <span key={l.key} className={`text-[9px] uppercase tracking-[0.06em] md:tracking-[0.12em] leading-tight ${i === idx ? "text-[#C49A6C]" : "text-[#4A4640]"}`}>{l[lang]}</span>
        ))}
      </div>
      <p className="text-xs text-[#8A857D] mt-3 leading-relaxed">{lang === "ar" ? level.desc_ar : level.desc_en}</p>
    </div>
  );
};

export const FragranceProfile = ({ product }) => {
  const { lang } = useLang();
  const gender = GENDERS.find((g) => g.key === product.gender);
  if (!gender && !product.complexity && !product.character) return null;
  return (
    <div className="mt-8" data-testid="fragrance-profile">
      {gender && (
        <div data-testid="profile-gender" className="py-5 border-t border-[#1E1C19] flex items-baseline justify-between gap-4">
          <Title>{CLASS_TITLES.gender[lang]}</Title>
          <span className="serif text-lg text-[#F2EBE1]" data-testid="profile-gender-value">{gender[lang]}</span>
        </div>
      )}
      <LevelScale field="complexity" levels={COMPLEXITY} value={product.complexity} lang={lang} />
      <LevelScale field="character" levels={CHARACTER} value={product.character} lang={lang} />
    </div>
  );
};
